import { AIChat, Close } from '@ecomm/shared-icons'

type Props = {
  readonly isOpen: boolean
}

/**
 * AIChat/Close icon for the AI Chat Button.
 * @returns JSX element for the collapse/expand button.
 */
export function ToggleIcons({ isOpen }: Props) {
  const sharedClasses = `absolute left-0 top-0 w-5 h-5 duration-300 ease-in-out ${isOpen ? 'rotate-180' : ''}`

  return (
    <span className="relative w-5 h-5">
      <AIChat
        data-testid="ai-chat-icon"
        className={`${sharedClasses} ${isOpen ? 'opacity-0' : ''}`}
      />
      <Close
        data-testid="close-icon"
        className={`${sharedClasses} ${isOpen ? '' : 'opacity-0'}`}
      />
    </span>
  )
}
